// @flow
import React from "react";
//$FlowFixMe
import "biologiatotal-ui/index.css";
import { render } from "react-snapshot";
import "moment/locale/pt-br";

import { ConnectedRouter, routerMiddleware, routerReducer } from "react-router-redux";
import { Root } from "./scenes/_root";

import thunkMiddleware from "redux-thunk";
import { createBrowserHistory } from "history";
import { Provider } from "react-redux";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import httpInterceptor from "./core/httpInterceptor";
import reducers from "./core/reducers";
import "./core/config";
import { QueryParamProvider } from "use-query-params";
import { Route } from "react-router-dom";
import { ReactQueryConfigProvider } from "react-query";
import "react-tippy/dist/tippy.css";
//eslint-disable-next-line no-unused-vars
import "./ql-editor-custom.css";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const history = createBrowserHistory();
//const loggerMiddleware = createLogger()

const middleware = [
  routerMiddleware(history),
  //  loggerMiddleware,
  thunkMiddleware
];

if (process.env.NODE_ENV !== "production") {
  //eslint-disable-next-line no-unused-vars
  //whyDidYouUpdate(React);
}

const store = createStore(
  combineReducers({
    ...reducers,
    router: routerReducer
  }),
  composeEnhancers(
    httpInterceptor({
      "403": (dispatch, response) => dispatch({ type: "APP/TOKEN_EXPIRED" })
    }),
    applyMiddleware(...middleware)
  )
);

export default (state, action) => (action.type === "USER_LOGOUT" ? store(undefined, action) : store(state, action));

const queryConfig = {
  refetchAllOnWindowFocus: false
};

render(
  <ReactQueryConfigProvider config={queryConfig}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <QueryParamProvider ReactRouterRoute={Route}>
          <Root />
        </QueryParamProvider>
      </ConnectedRouter>
    </Provider>
  </ReactQueryConfigProvider>,
  document.getElementById("root")
);
